import ActionButton from "components/Buttons/ActionButton";
import FeedbackProviderContext from "components/FeedbackProvider/context/FeedbackProviderContext";
import { useContext } from "react";

export default function ReportErrorButton({ errors, sx }) {
  const { setShowModal, setFeedback } = useContext(FeedbackProviderContext);

  return (
    <ActionButton
      sx={sx}
      onClick={() => {
        setFeedback(
          `An unhandled error occurred, the message returned by the API is: \n${errors.toString()}`,
        );
        setShowModal(true);
      }}
    >
      Report Error
    </ActionButton>
  );
}
